/**
 * App shell - provides the main layout structure for the contractor app.
 * Mobile-first design with sticky header, sync bar, and safe area handling.
 */

import type { ReactNode } from 'react';
import { Header } from './Header';
import { SyncStatusBar } from './SyncStatusBar';
import { BottomNav } from './BottomNav';

interface AppShellProps {
  children: ReactNode;
  title?: string;
  activeTab?: 'tasks' | 'time';
  onTabChange?: (tab: 'tasks' | 'time') => void;
  showBottomNav?: boolean;
}

export function AppShell({
  children,
  title,
  activeTab = 'tasks',
  onTabChange,
  showBottomNav = true,
}: AppShellProps) {
  return (
    <div className="min-h-screen flex flex-col bg-surface">
      <Header title={title} />
      <SyncStatusBar />
      <main className="flex-1 flex flex-col min-h-0 overflow-hidden">
        {children}
      </main>
      {showBottomNav && onTabChange && (
        <BottomNav activeTab={activeTab} onTabChange={onTabChange} />
      )}
    </div>
  );
}
